import { render, staticRenderFns } from "./CarLifeComponent.vue?vue&type=template&id=65c9b913&scoped=true"
import script from "./CarLifeComponent.vue?vue&type=script&lang=js"
export * from "./CarLifeComponent.vue?vue&type=script&lang=js"
import style0 from "./CarLifeComponent.vue?vue&type=style&index=0&id=65c9b913&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9b913",
  null
  
)

export default component.exports